import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-nav-21",
  "use": "icon-icon-nav-21-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-nav-21\"><path d=\"M511.68 192A319.872 319.872 0 0 0 192 512c0 176.64 143.04 320 319.68 320A320.192 320.192 0 0 0 832 512c0-176.64-143.36-320-320.32-320zM512 768c-141.44 0-256-114.56-256-256s114.56-256 256-256 256 114.56 256 256-114.56 256-256 256z m112-288a47.936 47.936 0 1 0 0-96 47.936 47.936 0 1 0 0 96z m-224 0a47.936 47.936 0 1 0 0-96 47.936 47.936 0 1 0 0 96zM512 688c74.56 0 137.92-46.72 163.52-112h-327.04c25.6 65.28 88.96 112 163.52 112z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/icon-nav-21.svg
// module id = qmSB
// module chunks = 3